module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABIElEQVQ4T4WRQU6DUBCG/wki295APYG9gfQE0qWxJO1CiEs3CivLiuqmSwMu2uRpXJbeAG9QT6DegK1BMgYKSfv6im/3Zuab+ecfgvSms1nnJ9enYJh1KjEO8+BmNMo2S0kGJ5FYgehUiqeeM+jtBR8iYTHRQm5W/pm451/ZaZPbmhhGYkxE90qQOfBde6wE2yYSc//OtRMlWAaVOzJ/eK7dbTWndnUO4LwuXBp6Pmx1NXx6OyatKHccSnvOudAC//ria0dq+CxMYiwA6qjMAThjQr9xtnJ1Le/gcz/UtOLM0H9PStkV2HYGeTrXZ1mDsUgJdKaWuB1l8Lvv2GYFTuKX8j6Ni//xS88ZWBX4GL92C3BCwFEbxcC3BrJuncvVHw9pcA/GG44ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon-login-user.png
// module id = 7GI0
// module chunks = 1